export class RestoreDynamoDbTableConfig {
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDynamoDbTableConfig.attributeTypeMap;
    }
    constructor() {
    }
}
